/**
 * @license
 *
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Built-in model middleware — `retry`, `fallback`, `augmentWithContext`,
 * `validateSupport`, and other middleware for enhancing model requests.
 *
 * ```ts
 * import { retry, fallback } from 'genkit/model/middleware';
 * ```
 *
 * @module model/middleware
 */

export {
  augmentWithContext,
  downloadRequestMedia,
  fallback,
  retry,
  simulateSystemPrompt,
  validateSupport,
  type AugmentWithContextOptions,
} from '@genkit-ai/ai/model/middleware';
